import angular from 'angular';

export default angular.module('cms.creator.number.with.unit.filter', [])
    .filter('numberWithUnit', function () {

        return function (numberWithUnitModel) {
            return numberWithUnitModel.value + numberWithUnitModel.unit;
        };
    }).name;





// WEBPACK FOOTER //
// ./src/cmsCore/NumberWithUnitFilter/NumberWithUnitFilter.js